import React, { useState, useEffect, useContext } from 'react';

import { GeneralContext } from '../app-context/GeneralContext';
import config from '../../config';
import { LoadingPage } from '../../shared/components/LoadingPage';
import { useActivateUserOnResource } from './use-activate-user-on-resource';
import { useGetStore } from './use-get-store';
import useGlobalStore from '../../shared/store/globalStore';
import AuthService from './AuthService';

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { setUser, setStore } = useContext(GeneralContext);
  const setUser2 = useGlobalStore((state) => state.general.setUser);
  const setStore2 = useGlobalStore((state) => state.general.setStore);
  const { activateUserOnResource, loading: userMutationLoading } =
    useActivateUserOnResource();
  const { getStoreByUser, loading: storeQueryLoading } = useGetStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const setupAfterLogin = async () => {
      const _userActiveOnResource = (attributes) => {
        return Object.keys(attributes).includes(
          `${config.env}_user_active_on_resource`,
        )
          ? attributes[`${config.env}_user_active_on_resource`][0] === 'true'
          : false;
      };
      if (AuthService.isAuthenticated()) {
        setLoading(true);
        const [userInfo, { attributes }] = await Promise.all([
          AuthService.getUserInfo(),
          AuthService.getUserProfile(),
        ]);
        const userActiveOnResource = _userActiveOnResource(attributes);
        if (!userActiveOnResource) {
          const activateUserSuccess = await activateUserOnResource({
            keycloakUserId: userInfo.sub,
            firstName: userInfo.given_name,
            lastName: userInfo.family_name,
            email: userInfo.email,
          });
          if (!activateUserSuccess) {
            AuthService.doLogout();
          }
        }
        // Get store by user, if not found, logout -> invalid login
        const store = await getStoreByUser({ userId: userInfo.sub });
        if (!store || !userInfo) {
          AuthService.doLogout();
        }
        // Set user info on context
        setUser({
          id: userInfo.sub,
          firstName: userInfo.given_name,
          lastName: userInfo.family_name,
          email: userInfo.email,
        });
        setUser2({
          id: userInfo.sub,
          firstName: userInfo.given_name,
          lastName: userInfo.family_name,
          email: userInfo.email,
        });
        // Set store on context
        setStore(store);
        setStore2(store);
        setLoading(false);
      } else {
        setLoading(false);
        AuthService.doLogin();
      }
    };
    setupAfterLogin();
  }, []);

  const isRoleAllowed = () => {
    if (allowedRoles.length > 0) {
      return AuthService.hasRole(allowedRoles);
    } else {
      return true;
    }
  };

  if (loading || userMutationLoading || storeQueryLoading) {
    return <LoadingPage />;
  } else if (AuthService.isAuthenticated() && isRoleAllowed()) {
    return children;
  } else {
    AuthService.doLogin();
  }
}
